import Header from "@components/Header/Header"
import PINInput from "@components/PINInput/PINInput"
import { useNavigate } from "react-router"
import { Container, ContentContainer } from "./ChangePIN.styles"
import { useTranslation } from "react-i18next"
import { TonWalletUtils } from "@lib/secrets"

const ChangePIN = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    return (
        <Container>
            <Header title={t('changePIN.header')} showBackButton={true} onBackClick={() => navigate('/security')} />
            <ContentContainer>
                <PINInput 
                    mode="change" 
                    onComplete={async (result) => {
                        await TonWalletUtils.storePin(result.newPin!)
                        navigate('/completed/pin-change')
                    }} 
                />
            </ContentContainer>
        </Container>
    )
}

export default ChangePIN